module.exports = __webpack_public_path__ + "static/media/IN_Payslip_1.5dfbda3f.png";